export default function (name: string, innerWidth:number) {
    if (innerWidth < 769 && name.length > 20){
        return `${(name).substring(0,19)}${(name).substring(19,20) !== " " ? (name || "").substring(19,20) : ""}...`
    }
    return name
}